import turtleLogo from "./turtle.svg";

export function TurtleLogo() {
	return (
		<div className="flex items-center justify-center mb-7">
			<img
				src={turtleLogo}
				alt="TuRTLe Logo"
				className="h-64 p-6 transition-all duration-300 drop-shadow-[0_0_1.35em_#026e00] scale-120 hover:drop-shadow-[0_0_0em_#026e00]"
			/>
		</div>
	)
};

export function TurtleButtons() {
	const baseClass = "cursor-pointer text-lg px-4 py-1 rounded-lg font-normal border transition-all duration-300 flex items-center gap-2";

	const ArrowIcon = () => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={2}
			stroke="currentColor"
			className="w-4 h-4"
		>
			<path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
		</svg>
	);

	return (
		<div className="mb-7">
			<div className="flex flex-wrap items-center justify-center gap-4 mt-8 mb-6">

				{/* GitHub */}
				<a
					className={`${baseClass} bg-white/5 border-white/20 text-gray-200 hover:bg-white/10 hover:border-white/20`}
					href="https://github.com/HPAI-BSC/TuRTLe"
					target="_blank"
				>
					GitHub repo
					<ArrowIcon />
				</a>

				{/* arXiv */}
				<a
					className={`${baseClass} bg-red-500/10 border-red-500/30 text-red-200 hover:bg-red-500/14 hover:border-red-500/40 hover:shadow-[0_0_5px_rgba(239,68,68,0.2)]`}
					href="https://arxiv.org/abs/2504.01986"
					target="_blank"
				>
					arXiv MLCAD 2025
					<ArrowIcon />
				</a>

				<a
					className={`${baseClass} bg-red-500/10 border-red-500/30 text-red-200 hover:bg-red-500/14 hover:border-red-500/40 hover:shadow-[0_0_5px_rgba(239,68,68,0.2)]`}
					href="https://arxiv.org/abs/2512.20823"
					target="_blank"
				>
					arXiv DAC 2026
					<ArrowIcon />
				</a>

				{/* Submit */}
				<a
					className={`${baseClass} bg-green-500/10 border-green-500/30 text-green-200 hover:bg-green-500/20 hover:border-green-500/40 hover:shadow-[0_0_5px_rgba(34,197,94,0.2)]`}
					href="mailto:hpai@bsc.es?subject=TuRTLe Leaderboard new entry&body=Link to HuggingFace model:"
					target="_blank"
				>
					Submit
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth={2}
						stroke="currentColor"
						className="w-5 h-5"
					>
						<path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
					</svg>
				</a>
			</div>

			<p className="text-normal">
				If you have any inquiries or wish to collaborate: <code className="bg-[#1a1a1a] px-2 py-1 rounded font-mono">hpai@bsc.es</code>
			</p>
		</div>
	)
};

export function TurtleIntro() {
	return (
		<div className="mb-6 max-w-4xl mx-auto">
			<p className="text-sm text-left leading-relaxed text-gray-400/80">
				TuRTLe is a <strong>unified evaluation framework designed to systematically assess Large Language Models (LLMs) in RTL (Register-Transfer Level) generation</strong> for hardware design. Evaluation criteria include <strong>syntax correctness, functional accuracy, synthesizability, and post-synthesis quality</strong> (PPA). Use the filters below to explore different RTL benchmarks, simulators and models.
			</p>
		</div>
	)
}
